// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"170c5699","340":"0e546c89","586":"8f644d0a","828":"74209645"}[chunkId] + ".chunk.css";
};